import { SharedModule } from "@shared";
import { BrowserModule, Title } from "@angular/platform-browser";
import { isDevMode, NgModule } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CoreModule } from "./core/core.module";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import ru from "@angular/common/locales/ru";
import ua from "@angular/common/locales/uk";
import en from "@angular/common/locales/en";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "@env";
import { EffectsModule } from "@ngrx/effects";
import { StoreRouterConnectingModule } from "@ngrx/router-store";
import { RouterEffects } from "@pressure-state/router";

import { MapDevicesModule } from "@radmirtech-ui-cdk/map-devices";

// Cache-bust перекладів відв'язаний від semver: токен формується один раз на
// завантаження застосунку (отже змінюється і на кожній новій збірці), тому нові
// ключі в assets/i18n/*.json завжди підхоплюються, не чекаючи зміни version.
// Компроміс: i18n не кешується між перезавантаженнями (файл невеликий, а SW для
// i18n і так працює за стратегією freshness — мережа в пріоритеті).
const I18N_CACHE_BUST: number = Date.now();

export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(
    http,
    "../../../../assets/i18n/",
    `.json?v=${I18N_CACHE_BUST}`,
  );
}
registerLocaleData(en);
registerLocaleData(ua);
@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreModule,
    SharedModule,
    BrowserModule,
    AppRoutingModule,
    StoreRouterConnectingModule.forRoot(),
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      useDefaultLang: false,
    }),
    MapDevicesModule.forRoot({
      mapServerUrl: "http://178.63.67.126:9989",
      nominationApiUrl: "http://178.63.67.126:9989",
      debug: isDevMode(),
    }),
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    EffectsModule.forRoot([RouterEffects]),
  ],
  providers: [Title],
  bootstrap: [AppComponent],
})
export class AppModule {}
